<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import Style from "@/views/layouts/style";
import DontExist from "@/components/company/components/DontExist"
import puntuationAPI from "@/services/standards/puntuation/puntuationAPI";
import evaluacionIdentificacionAPI from "../../../../services/standards/evaluacionIdentificacion/evaluacionIdentificacionAPI";

/**
 * Form elements component
*/
export default {
  page: {
    title: "Reporte",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Style,
    DontExist,

  },
  data() {
    return {
      title: "Reporte",
      loading: true,
      items: [],
      excel: null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      companies_id: this.$store.getters["company/getCompany"].id || null,
      user: this.$store.state.auth.user.token || null,

      evaluacion: {
        access_token: this.$store.state.auth.user.token
      },
    };
  },
  computed: {},

  methods: {
    getList() {
      puntuationAPI.getpuntuation(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    async print() {
      try {
        evaluacionIdentificacionAPI.getExcel(this.companyID)
          .then((response) => {
            this.excel = response;
          })

        const url = this.excel;
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    getActa() {
      evaluacionIdentificacionAPI.getExcel(this.companies_id, { access_token: this.evaluacion.access_token })
        .then((response) => {
          this.excel = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getList();
    this.getActa();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">

          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="row">
                  <div class="col-lg-12">
                    <div class="card-body">

                      <div class="table-responsive">

                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr>
                              <td class="text-center align-middle">
                                <h3> <span class="badge badge-pill badge-primary">Descargar reporte de avance</span>
                                </h3>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">

                                  <button @click="print" class="btn btn-primary mx-1" id="tooltip">
                                    <span class="btn-label"> <i class="bx bx-download"></i></span> Descargar
                                  </button>

                                  <b-tooltip target="tooltip" placement="left">
                                    Descargar reporte de avance
                                  </b-tooltip>
                                </div>
                              </td>
                            </tr>

                            <!-- <tr>
                              <td class="text-center align-middle">
                                <h3> <span class="badge badge-pill badge-primary">Reportes - Caracterización de la
                                    accidentalidad</span>
                                </h3>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">

                                  <button class="btn btn-primary mx-1" id="tooltip">
                                    <router-link class="text-white"
                                      :to="{ path: `/forms/caracterizacion-accidentalidad` }"><span
                                        class="btn-label"></span>Ir a Caracterización de la
                                      accidentalidad
                                    </router-link>
                                  </button>

                                  <b-tooltip target="tooltip1" placement="left">
                                    Reportes - Caracterización de la
                                    accidentalidad
                                  </b-tooltip>
                                </div>
                              </td>
                            </tr> -->

                          </tbody>
                        </table>

                        <div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- end col -->
                </div>

              </div>
            </div>

          </div>
        </div>

        <div v-else-if="!loading && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>